import "./HowItWorks.css";

import { Container, Stack, Typography } from '@mui/material';
import lawyer from '../images/lawyer.png';
import Box from '@mui/material/Box';

const HowItWorks = () => {
    return (
        <>
            <Container maxWidth="xl" sx={{ backgroundColor: "#ffffff", paddingY: 10, textAlign: "center", width: "100%", }}>
                <div id="hiw" className="howitworks"><Typography variant="h4">Assistant Government Pleader  / Public Procecutor</Typography></div>

                <div className="divver">
                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>Mr. Ashutosh S. Dave</Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>

                            </div>
                        </Stack>
                    </Box>
                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>Mr. Sahil B. Trivedi
                                </Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>

                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>MR. JAY B. TRIVEDI</Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>

                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>Ms. Jyoti N Bhatt</Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>


                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>MS. POOJA K
                                </Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>

                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>MS SUMAN MOTLA</Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Government Pleader - AGP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>
                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>MR. L. B. DABHI</Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Public Procecutor - <br></br>APP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>

                    <Box sx={{ border: '1px solid #000', padding: 2 }}>
                        <Stack sx={{ paddingX: 5, }}>
                            <img src={lawyer} width="200" alt="turnon" style={{ margin: '0 auto' }} />
                            <div className="tiles">
                                <Typography textAlign="center" variant="h5" fontWeight="450" sx={{ marginTop: 3, }}>MR. SOAHAM </Typography><br></br>
                                <Typography textAlign="center" variant="h7">Assistant Public Procecutor - <br></br>APP</Typography><br></br><br></br>
                                <Typography textAlign="center" variant="h7">High Court Of Gujarat</Typography>
                            </div>
                        </Stack>
                    </Box>
                </div>
            </Container>
        </>
    )
}

export default HowItWorks;
